interface V3IconPodcastProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconPodcast = ({ stroke = "#ABB0BA", ...rest }: V3IconPodcastProps) => <svg width="16" height="16" {...rest} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 12V4M2 9V7M8 11V5M11 13V3M14 10V6" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>